module.exports = __webpack_public_path__ + "img/rectangularTrapezoidHorizontal.b56a4596.svg";